import { configureStore } from '@reduxjs/toolkit'
import storageSession from 'reduxjs-toolkit-persist/lib/storage/session'
import { persistReducer, persistStore } from 'redux-persist';

import monitorReducersEnhancer from './store/enhancers/monitorReducer'
import loggerMiddleware from './store/middleware/logger'
import rootReducer from './store/reducers';
import initialState from './store/state';

const persistConfig = {
    key: 'root',
    storage: storageSession,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

// export default function configureAppStore(preloadedState) {
//     const store = configureStore({
//         reducer: persistedReducer,
//         middleware: (getDefaultMiddleware) => getDefaultMiddleware({
//             serializableCheck: false
//         }).concat(loggerMiddleware),
//         preloadedState,
//         enhancers: [monitorReducersEnhancer]
//     })

//     return store
// }

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }).concat(loggerMiddleware),
    preloadedState: initialState,
    enhancers: [monitorReducersEnhancer]
});

export const persistor = persistStore(store)